import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CardComponent } from './card.component';
import { CardHeaderComponent } from './card-header.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    CardComponent,
    CardHeaderComponent
  ],
  exports: [
    CardComponent,
    CardHeaderComponent
  ]
})
export class CardModule { }
